module.exports = __webpack_public_path__ + "img/restaurant-view-tabs01.dd0604c9.svg";